const tableButtonTypes = {
  edit: 'edit',
  delete: 'delete',
};

export default tableButtonTypes;
